import segment from '@/services/segment'
import { GlobalVars } from '@/services/globals'

const segmentPlugin = {
  install (app) {
    app.config.globalProperties.$segment = segment
    GlobalVars.$segment = segment
  }
}

export default segmentPlugin
